import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [online, setOnline] = useState(navigator.onLine);
  const [notes, setNotes] = useState([]);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  useEffect(() => {
    const saved = localStorage.getItem('offlineNotes');
    if (saved) {
      setNotes(JSON.parse(saved));
    }

    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);
    
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  useEffect(() => {
    localStorage.setItem('offlineNotes', JSON.stringify(notes));
  }, [notes]);

  const addNote = () => {
    if (title.trim() || content.trim()) {
      setNotes([...notes, {
        id: Date.now(),
        title: title || 'Untitled',
        content,
        created: new Date().toLocaleString()
      }]);
      setTitle('');
      setContent('');
    }
  };

  const deleteNote = (id) => {
    setNotes(notes.filter(note => note.id !== id));
  };

  return (
    <div className="App">
      <h1>Offline PWA</h1>
      
      <div className={`status ${online ? 'online' : 'offline'}`}>
        Status: {online ? '🟢 Online' : '🔴 Offline'}
      </div>

      <div className="add-note">
        <h2>Add Note</h2>
        <input 
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <textarea 
          placeholder="Content"
          rows="4"
          value={content}
          onChange={(e) => setContent(e.target.value)}
        />
        <button onClick={addNote}>Add Note</button>
      </div>
      
      <h2>Notes ({notes.length})</h2>
      {notes.length === 0 ? (
        <p>No notes yet. Add one above!</p>
      ) : (
        <div className="notes-list">
          {notes.map(note => (
            <div key={note.id} className="note">
              <h3>{note.title}</h3>
              <p>{note.content}</p>
              <small>{note.created}</small>
              <button onClick={() => deleteNote(note.id)}>Delete</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default App;